import React from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

import { selectIsUserLogged } from '@selectors/auth';

import { getRouteUrl } from '@utils/urls';

import { PRE_LOGIN } from '@common/routes';
import { VARIANT_QUATERNARY } from '@common/constants/alertBox';

import { LoginMessageBox } from './LoginMessage.styled';

const LoginMessage = () => {
  const { t } = useTranslation();
  const { asPath, locale } = useRouter();
  const isUserLogged = useSelector(selectIsUserLogged);

  if (isUserLogged) {
    return null;
  }

  const targetQuery = { target: `/${locale}${asPath}` };
  const loginLink = {
    href: {
      pathname: PRE_LOGIN,
      query: targetQuery,
    },
    as: {
      pathname: getRouteUrl(locale, PRE_LOGIN),
      query: targetQuery,
    },
  };

  return (
    <LoginMessageBox
      title={t(
        'global.info.useAccountData.title',
        'Angaben von deinem VIP-Profil übernehmen?',
      )}
      description={t(
        'global.info.useAccountData.description',
        'Wenn Du Dich anmeldest füllen wir alle möglichen Felder mit Deinen Angaben für Dich aus.',
      )}
      buttonText={t('global.info.useAccountData.button', 'Einloggen')}
      link={loginLink}
      variant={VARIANT_QUATERNARY}
    />
  );
};

export default LoginMessage;
